import config from "@Config/index";
import axios from "axios";
import getCookie from "helpers/getCookie";

export default async function fetchPaymentInfo({
  id,
  inventory_id,
  source,
  nationality,
  userCurrency = "",
}: {
  id: string;
  inventory_id: any;
  source: string;
  nationality?: string;
  userCurrency?: string;
}) {
  const url = `${config.API_URL}/api/v0/inventories/${id}`;
  const params: any = {
    type: "empty",
    id: `${id}`,
    inventory_id: `${inventory_id}`,
    methods: "payment_info",
    cache: false,
    use_java_api: true,
  };

  if (nationality) {
    params["nationality"] = nationality;
  }

  if (userCurrency) params.user_currency = userCurrency;

  const headers = {
    "X-Use-Java-Api": "true",
    Cookie: `user_flow_token=${getCookie("user_flow_token")}${
      userCurrency ? `; user_currency=${userCurrency}` : ""
    }`,
  };

  try {
    const {
      data: {
        data: { payment_info = [] },
      },
    } = await axios.get(url, { params, headers, withCredentials: true });

    if (payment_info && payment_info?.length > 0 && typeof sessionStorage !== "undefined") {
      sessionStorage.setItem("PAYMENT_INFO", JSON.stringify(payment_info));
    }

    return {
      payment_info,
    };
  } catch (error) {
    if (typeof window !== undefined && typeof window.Sentry !== "undefined") {
      window.Sentry.captureException(`Error in fetching payment details`, {
        extra: {
          request: JSON.stringify(params),
          response: error,
        },
      });
    }
    console.error("Error fetching payment info from ", source, " :", error);
    throw error;
  }
}
